import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus,
  Heading,
  HeadingDisplay,
  Grid,
  Row,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ObjectiveCard } from './components/ObjectiveCard';
import { WalletCard } from './components/WalletCard';

import { getCatalog, ICatalog } from '@/modules/catalog/services/catalog';


export default /*#__PURE__*/_defineComponent({
  __name: 'Catalog',
  setup(__props) {

const router = useRouter();

const catalog = ref<ICatalog | null>(null);
const isLoading = ref(true);
const hasError = ref(false);

const objectivePortfolio = computed(() => {
  return catalog.value?.recommended.portfolios[0];
});

function handleBack() {
  router.push({ name: 'wealth' });
}

function goToFundsBuilder(type: string, askForInvestorType: boolean) {
  const query = askForInvestorType
    ? { qualifiedInvestor: String(askForInvestorType) }
    : {};

  router.push({
    name: 'fundsAcquisition',
    params: { type },
    query
  });
}

function goToVariableIncomeBuilder(id: string) {
  router.push({
    name: 'variableIncomeAcquisition',
    params: { id }
  });
}

function goToManualBuilder() {
  router.push({ name: 'wealthBuilderView' });
}

async function fetchCatalog() {
  try {
    isLoading.value = true;
    hasError.value = false;

    catalog.value = await getCatalog();
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onBeforeMount(async () => {
  await fetchCatalog();
});

return { __sfc: true,router, catalog, isLoading, hasError, objectivePortfolio, handleBack, goToFundsBuilder, goToVariableIncomeBuilder, goToManualBuilder, fetchCatalog, NavBar, LoaderIndicator, HelperViewStatus, Heading, HeadingDisplay, Grid, Row, InitialAvatarIcon, BackButton, ObjectiveCard, WalletCard }
}

})